import "../../assets/css/login.css";
import logo from "../../assets/images/logo.png";
import axios from "axios";
import { LOGIN } from "../../routes/routes";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { ValidationMessage } from "../../components/Utils";

import { useApplicationContext } from "../../context/ApplicationContext";

const LoginPage = () => {
  const { setUserAndPermissions } = useApplicationContext();
  // ## State Variables
  const [type, setType] = useState("password");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  // Navigation
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  /**
   * @API call for Login Authentication
   */
  const submit = (e) => {
    e.preventDefault();
    setBtnDisabled(true);
    axios
      .post(LOGIN, form)
      .then((response) => {
        if (response?.data?.success && response?.data?.code === 200) {
          const userData = response.data.data;
          const userPermissions = response.data.data.permissions;

          localStorage.setItem("token", userData.token);
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem("permissions", JSON.stringify(userPermissions));

          setUserAndPermissions(userData, userPermissions);

          toast.success(response.data.msg);
          navigate(from, { replace: true });
        }
      })
      .catch((error) => {
        if (
          !error?.response?.data?.success &&
          error?.response?.status === 422
        ) {
          setErrors(error?.response?.data?.error);
          toast.error(error?.response?.data?.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="login-pg">
        {/* ── Left Hero Panel ─────────────────── */}
        <div className="col-lg-7 bg-wrappers d-none d-lg-block p-0">
          <div className="login-bg">
            {/* Animated floating shapes */}
            <div className="login-bg-shapes" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </div>

            {/* Hero brand copy — inside login-bg so flex centering works */}
            <div className="login-hero-content">
              <h2>
                Connecting Business.
                <br />
                Creating Opportunities.
              </h2>
              <p>
                The all-in-one platform for Builders world forum — manage
                members, track referrals, and grow your network effortlessly.
              </p>
              <div className="login-stats">
                <div className="login-stat-pill">
                  <i className="bx bx-group"></i>
                  Members &amp; Chapters
                </div>
                <div className="login-stat-pill">
                  <i className="bx bx-calendar-check"></i>
                  Attendance &amp; Events
                </div>
                <div className="login-stat-pill">
                  <i className="bx bx-line-chart"></i>
                  Leads &amp; Reports
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Right Form Panel ─────────────────── */}
        <div className="col-lg-5 col-md-12 col-sm-12 p-0">
          <div className="login-wrappers">
            <div className="login-container">
              {/* Logo + Welcome */}
              <div className="login-content">
                <img src={logo} className="login-logo-one" alt="BWF Logo" />
                {/* <div className="login-welcome">
                  <h1>Welcome back</h1>
                  <p>Sign in to access your dashboard</p>
                </div> */}
              </div>

              {/* Divider */}
              <div className="login-divider">
                <span></span>
                <small>Sign in with credentials</small>
                <span></span>
              </div>

              {/* Form */}
              <form
                id="formAuthentication"
                className="mb-3"
                onSubmit={submit}
                method="POST"
                autoComplete="off"
                autoFocus="off"
              >
                {/* Email */}
                <div className="login-field-group">
                  <label htmlFor="email" className="theme-label">
                    Email Address
                  </label>
                  <div className="login-input-wrap">
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="you@example.com"
                      autoFocus
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                    />
                    <i className="bx bx-envelope input-icon"></i>
                  </div>
                  <ValidationMessage error={errors} name="email" />
                </div>

                {/* Password */}
                <div className="login-field-group form-password-toggle">
                  <label className="theme-label" htmlFor="password">
                    Password
                  </label>
                  <div className="login-input-wrap input-group input-group-merge">
                    <input
                      type={type}
                      id="password"
                      className="form-control"
                      name="password"
                      placeholder="Enter your password"
                      aria-describedby="toggle-password"
                      onChange={(e) =>
                        setForm({ ...form, password: e.target.value })
                      }
                    />
                    <i className="bx bx-lock-alt input-icon"></i>

                    {type === "password" ? (
                      <span
                        className="input-group-text cursor-pointer"
                        id="toggle-password"
                        onClick={() => setType("text")}
                        title="Show password"
                      >
                        <i className="bx bx-hide"></i>
                      </span>
                    ) : (
                      <span
                        className="input-group-text cursor-pointer"
                        id="toggle-password"
                        onClick={() => setType("password")}
                        title="Hide password"
                      >
                        <i className="bx bx-show"></i>
                      </span>
                    )}
                  </div>
                  <ValidationMessage error={errors} name="password" />
                </div>

                {/* Submit */}
                <div className="mt-4 mb-3">
                  <button
                    disabled={btnDisabled}
                    className="btn btn-primary login-submit d-grid w-100"
                    type="submit"
                    id="login-submit-btn"
                  >
                    {btnDisabled ? "Signing in…" : "Sign in"}
                  </button>
                </div>
              </form>

              {/* Footer Credit */}
              {/* <div className="login-dev text-center">
                <a
                  href="https://www.innoblitz.global/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Design &amp; Developed By&nbsp;
                  <span>Innoblitz Technologies and Systems Pvt Ltd.</span>
                </a>
              </div> */}
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
      </div>
    </div>
  );
};

export default LoginPage;
